import client from '@/utils/shopify';
import { useRouter } from 'next/router';

// DEPRECATED, WE DO NOT USE CARTS ANYMORE
// const itemInCart = (cart: ShopifyBuy.Cart, variantId: string) =>
//   cart.lineItems.find(
//     // need to use 'any' because typing lib is not updated
//     (v: any) => !!v.variant.id && v.variant.id === variantId
//   );
export const fetchUnwrapper = (obj: any) => JSON.parse(JSON.stringify(obj));

// DEPRECATED, WE DO NOT USE CARTS ANYMORE
// need to do this because types are not updated for shopify-js-buy-sdk.
// const getCartPrice = (shopifyCart: any): string =>
//   shopifyCart?.subtotalPrice?.amount || '0';

export default function useShopify() {
  const router = useRouter();
  // DEPRECATED, WE DO NOT USE CARTS ANYMORE
  // const [cart, setCart] = useState<ShopifyBuy.Cart>();
  // DEPRECATED, WE DO NOT USE CARTS ANYMORE
  // const [isLoading, setIsLoading] = useState(true);

  // DEPRECATED, WE DO NOT USE CARTS ANYMORE
  // useEffect(() => {
  //   const findOrCreateCart = async () => {
  //     try {
  //       const cartKey = window.localStorage.getItem(SHOPIFY_CART_ID) ?? '';
  //       const existingCart = await client.checkout.fetch(cartKey);

  //       if (!existingCart) {
  //         const newCart = await client.checkout.create();
  //         setCart(fetchUnwrapper(newCart));
  //         window.localStorage.setItem(SHOPIFY_CART_ID, newCart.id + '');
  //       } else {
  //         setCart(fetchUnwrapper(existingCart));
  //       }
  //     } catch (error) {
  //       const newCart = await client.checkout.create();
  //       setCart(fetchUnwrapper(newCart));
  //       window.localStorage.setItem(SHOPIFY_CART_ID, newCart.id + '');
  //     }
  //   };

  //   findOrCreateCart().then((_) => setIsLoading(false));
  // }, []);

  // DEPRECATED, WE ARE NOT USING THIS ANYWHERE
  // const findCollections = async () => {
  //   const collections = await client.collection.fetchAllWithProducts();
  //   // Do something with the collections
  //   return fetchUnwrapper(collections);
  // };

  // DEPRECATED, IN TWO WAYS
  // 1. WE ARE NOT USING THIS FUNCTIONALITY AFTER WE MIGRATED TO MULTI-VENDOR-MARKETPLACE
  // 2. WE ARE MIGRATING THE SHOPIFY GRAPHQL CLIENT
  // const addToCart = async (variantId: string, totalInventory: number) => {
  //   const item: ShopifyBuy.LineItem | undefined = itemInCart(
  //     cart as ShopifyBuy.Cart,
  //     variantId
  //   );

  //   if (!item || totalInventory > item.quantity) {
  //     client.checkout
  //       .addLineItems(cart?.id as string | number, [{ variantId, quantity: 1 }])
  //       .then((checkout) => setCart(fetchUnwrapper(checkout)));
  //   }
  // };

  // DEPRECATED, IN TWO WAYS
  // 1. WE ARE NOT USING THIS FUNCTIONALITY AFTER WE MIGRATED TO MULTI-VENDOR-MARKETPLACE
  // 2. WE ARE MIGRATING THE SHOPIFY GRAPHQL CLIENT
  // const removeFromCart = async (variantId: string) => {
  //   const item: ShopifyBuy.LineItem | undefined = itemInCart(
  //     cart as ShopifyBuy.Cart,
  //     variantId
  //   );

  //   if (item)
  //     client.checkout
  //       .updateLineItems(cart?.id as string | number, [
  //         { id: item.id, quantity: item.quantity - 1 },
  //       ])
  //       .then((checkout) => setCart(fetchUnwrapper(checkout)));
  // };

  const buyNowExpressCheckout = async (variantId: string) => {
    const operation = `mutation createCart($cartInput: CartInput) {
      cartCreate(input: $cartInput) {
        cart {
          id
          checkoutUrl
          lines(first: 10) {
            edges {
              node {
                id
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                  }
                }
              }
            }
          }
          cost {
            totalAmount {
              amount
              currencyCode
            }
          }           
        }
      }
    }`;

    const res = await client.request(operation, {
      variables: {
        cartInput: {
          lines: [
            {
              quantity: 1,
              merchandiseId: variantId,
            },
          ],
        },
      },
      headers: {
        'X-Shopify-Storefront-Access-Token': 'd360ee804c40e46715eff2e6ed1b6216',
        'Content-Type': 'application/json',
      },
    });

    // const storefrontPassword = 'PEQtEXPh72';
    let checkoutUrl = res.data.cartCreate.cart.checkoutUrl;

    await router.push(checkoutUrl);
  };

  // DEPRECATED, WE DO NOT USE CARTS ANYMORE
  // const goToCheckout = () => {
  //   router.push(cart?.webUrl as string);
  // };

  return {
    // addToCart,
    // removeFromCart,
    client,
    buyNowExpressCheckout,
    fetchUnwrapper,
    // findCollections,
    // cart,
    // isLoading,
    // goToCheckout,
    // getCartPrice,
  };
}
